import { animate, keyframes, style, transition, trigger } from '@angular/animations';

export const LIST_CARD_ANIMATIONS = [
    trigger('clipboardCopied', [
        transition(':enter', animate('300ms ease-in-out', keyframes([
            style({
                opacity: '0'
            }),
            style({
                opacity: '1'
            })
        ]))),
        transition(':leave', animate('300ms ease-in-out', keyframes([
            style({
                opacity: '1'
            }),
            style({
                opacity: '0'
            })
        ])))
    ])
];
